import PropTypes from "prop-types";
import React from "react";
import { defaultTemplate } from "core/hoc";
import { BasicInput, BaasicButton, BaasicFieldDropdown } from "core/components";

function DressingBoxTemplate({ box, woundOrderAddWoundDressingViewStore }) {
    const handleRemove = () => {
        woundOrderAddWoundDressingViewStore.deleteDressing(box);
    };

    if (!box.editing || woundOrderAddWoundDressingViewStore.showSummary) {
        return (
            <div className="card--facility__primary">
                <div className="card--facility__side">
                    <div className="card--facility__side--title">
                        <span className="u-icon u-icon--xmed u-icon--layer u-mar--right--sml"></span>
                        {box.applicationTypeName}
                    </div>
                </div>
                <div className="card--facility__content">
                    <div className="card--facility__wrapper">
                        <table className="card__column-list">
                            <tr>
                                <td className="is-first type--wgt--bold">
                                    {box.productName}
                                </td>
                                <td className="type--color--black type--wgt--bold">
                                    <span className="type--wgt--regular">
                                        FOC:{" "}
                                    </span>{" "}
                                    {box.frequencyOfCareName}
                                </td>
                                <td className="type--color--black type--wgt--bold">
                                    <span className="type--wgt--regular">
                                        Treatment Duration:{" "}
                                    </span>{" "}
                                    {box.treatmentDuration != 0
                                        ? box.treatmentDuration
                                        : "None listed/≥28 days"}
                                </td>
                            </tr>
                        </table>
                        {woundOrderAddWoundDressingViewStore.showSummary && (
                            <table className="card--facility__tag">
                                {box.isCalculated &&
                                    box.woundCareResultCovered != null && (
                                        <tr>
                                            <td className="tag">
                                                {box &&
                                                    box.woundCareResultCovered && (
                                                        <span className="tag__icon tag__icon--green">
                                                            {
                                                                box
                                                                    .woundCareResultCovered
                                                                    .quantity
                                                            }
                                                        </span>
                                                    )}
                                                <span className="tag__label">
                                                    Eligible
                                                </span>
                                            </td>
                                        </tr>
                                    )}
                                {box.isCalculated &&
                                    box.woundCareResultNoDocumentation !=
                                        null && (
                                        <tr>
                                            <td className="tag">
                                                {box &&
                                                    box.woundCareResultNoDocumentation && (
                                                        <span className="tag__icon tag__icon--yellow">
                                                            {
                                                                box
                                                                    .woundCareResultNoDocumentation
                                                                    .quantity
                                                            }
                                                        </span>
                                                    )}
                                                <span className="tag__label">
                                                    Missing Docs
                                                </span>
                                            </td>
                                            <td className="tag__description">
                                                {
                                                    box.documentationNeededDescription
                                                }
                                            </td>
                                        </tr>
                                    )}
                                {box.isCalculated &&
                                    box.woundCareResultNonCovered != null && (
                                        <tr>
                                            <td className="tag">
                                                {box &&
                                                    box.woundCareResultNonCovered && (
                                                        <span className="tag__icon tag__icon--red">
                                                            {
                                                                box
                                                                    .woundCareResultNonCovered
                                                                    .quantity
                                                            }
                                                        </span>
                                                    )}
                                                <span className="tag__label">
                                                    Not Eligible
                                                </span>
                                            </td>
                                            <td className="tag__description">
                                                {
                                                    box.nonCoveredReasonDescription
                                                }
                                            </td>
                                        </tr>
                                    )}
                                {box.isCalculated && 
                                    box.woundCareResultOrderIssue != null &&(
                                        <tr>
                                            <td className="tag">
                                                <span className="tag__label">
                                                    Order Issue
                                                </span>
                                            </td>
                                            <td className="tag__description">
                                                {
                                                    box.orderIssueDescription
                                                }
                                            </td>
                                        </tr>
                                    )}
                            </table>
                        )}
                    </div>
                    {!woundOrderAddWoundDressingViewStore.showSummary && (
                        <div className="card__options">
                            <BaasicButton
                                className="btn btn--icon"
                                icon="u-icon u-icon--edit u-icon--sml"
                                label="Edit dressing details"
                                onlyIcon={true}
                                onClick={() =>
                                    woundOrderAddWoundDressingViewStore.switchBoxEditFlag(
                                        box
                                    )
                                }
                            />
                            <BaasicButton
                                onClick={() =>
                                    woundOrderAddWoundDressingViewStore.deleteDressing(
                                        box
                                    )
                                }
                                className="btn btn--icon u-mar--left--sml"
                                label="Delete wound dressing"
                                icon="u-icon u-icon--delete u-icon--sml"
                                onlyIcon={true}
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    } else {
        return (
            <div className="card--facility__primary">
                <div className="card--facility__side">
                    <div className="card--facility__side--title">
                        <span className="u-icon u-icon--xmed u-icon--layer u-mar--right--sml"></span>
                        {
                            woundOrderAddWoundDressingViewStore.dressingForm.$(
                                "applicationTypeAbrv"
                            ).value
                        }
                    </div>
                </div>
                <div className="card--facility__content">
                    <div className="card--facility__wrapper">
                        <div className="form__group col col-lrg-8 u-mar--bottom--sml">
                            <BaasicFieldDropdown
                                field={woundOrderAddWoundDressingViewStore.dressingForm.$(
                                    "selectedProductId"
                                )}
                                store={
                                    woundOrderAddWoundDressingViewStore.dressingStore
                                }
                            />
                        </div>

                        <div className="form__group col col-med-4 u-mar--bottom--sml">
                            <BaasicFieldDropdown
                                field={woundOrderAddWoundDressingViewStore.dressingForm.$(
                                    "applicationTypeId"
                                )}
                                store={
                                    woundOrderAddWoundDressingViewStore.applicationTypeStore
                                }
                            />
                        </div>

                        <div className="form__group col col-med-4 u-mar--bottom--sml">
                            <BaasicFieldDropdown
                                field={woundOrderAddWoundDressingViewStore.dressingForm.$(
                                    "frequencyOfCareId"
                                )}
                                store={
                                    woundOrderAddWoundDressingViewStore.frequencyOfCareStore
                                }
                            />
                        </div>

                        <div className="form__group col col-med-4 u-mar--bottom--med">
                            <BaasicFieldDropdown
                                field={woundOrderAddWoundDressingViewStore.dressingForm.$(
                                    "treatmentDurationCategory"
                                )}
                                store={
                                    woundOrderAddWoundDressingViewStore.treatmentDurationStore
                                }
                            />
                        </div>
                        {woundOrderAddWoundDressingViewStore.dressingForm.$(
                            "treatmentDurationCategory"
                        ).value === "lessThan30" && (
                            <div className="form__group col col-med-2 u-mar--bottom--sml">
                                <div>
                                    <BasicInput
                                        field={woundOrderAddWoundDressingViewStore.dressingForm.$(
                                            "treatmentDuration"
                                        )}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="card--facility__options--col">
                        <BaasicButton
                            onClick={handleRemove}
                            onlyIcon={true}
                            className="btn btn--icon"
                            icon="u-icon u-icon--delete u-icon--sml"
                        />
                        <div>
                            <BaasicButton
                                className="btn btn--base btn--primary u-mar--right--sml"
                                label="Save dressing"
                                onClick={() =>
                                    woundOrderAddWoundDressingViewStore.saveDressing(
                                        box
                                    )
                                }
                            />
                            <BaasicButton
                                className="btn btn--base btn--primary u-mar--right--sml"
                                label="Cancel"
                                onClick={() =>
                                    woundOrderAddWoundDressingViewStore.switchBoxEditFlag(
                                        box
                                    )
                                }
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

DressingBoxTemplate.propTypes = {
    woundOrderAddWoundDressingViewStore: PropTypes.object,
    t: PropTypes.func,
    box: PropTypes.object
};

export default defaultTemplate(DressingBoxTemplate);
